module.exports = __webpack_public_path__ + "img/img1.163834b6.png";